import React, { Component } from 'react';
import { database  } from '../config/base'
import HomeImg from '../assets/img/questionsheader.png'
import { Link } from 'react-router-dom';
import flesh from '../assets/img/flesh.png'
import imgTerminer from '../assets/img/terminer.png'
class Home extends Component {

  constructor() {
    super();
    this.state = {
      selectedItem:"selected",
      gameFinished:false,
      actualQuestion:0,
      questions: [
                  'Le super smartphone Allure M2 est doté de :',
                  'Le Plume L1 offre une expérience visuelle hors du commun grâce à son : ',
                  'Le nouveau smartphone Plume H1 est doté d’un processeur  :',
                  'Le nouveau smartphone Plume H1 se compose d’un processeur ',
                  'Le nouveau smartphone Plume P8 Pro se caractérise par la puissance de sa batterie qui est de  :'
      ],
      responses:
          {
          0:[
              'Quatre Caméras',
              'Full Screen 18:9',
              'Super batterie de 4000mAh'
            ],
            1:[
              'Ecran 5,5 pouce IPS HD.',
              'Full Screen 16:9 pour une magnifique expérience visuelle.',
              'Full Screen 18:9 pour une magnifique expérience visuelle.'
            ],
            2:[
              'Snapdragon 625 Octa Core 2.0Ghz',
              'Quad Core 1.25Ghz',
              'Quad Core 1.3 Ghz'
            ],
            3:[
              'CPU Super puissant Octa core 2.0Ghz',
              'CPU Super puissant Octa core 2.5Ghz',
              'CPU Super puissant Octa core 3.0Ghz.'
            ],
            4:[
              'Super batterie de 35000mAh',
              'Super batterie de 3000mAh',
              'Super batterie de 4000mAh'
            ]
        },

    };

  }

makeSelected(i)
{

    this.setState({
      selectedItem:"selected"+i
    })

}
  componentWillUnmount()
  {

    this.setState({

    })

  }

  goNextQuestion()
  {
    var _this = this;
    if (_this.state.actualQuestion<4)
    {
      _this.setState({
        actualQuestion:_this.state.actualQuestion+1
      })
    }
    else
    {
        this.setState({
          gameFinished:true
        })
    }

  }

  getPosts()
  {
        var _this = this;

        var TempArray= [];

        database.ref('/posts/').orderByKey().limitToFirst(_this.state.limitToFirstNum).on('value',function(snapshot) {

          TempArray= [];

          snapshot.forEach(function(childSnapshot)
          {
              var item = childSnapshot.val();

              item.key = childSnapshot.key;

              TempArray.push(item);

          });

          _this.setState((prevState, props) => ({
            limitToFirstNum: snapshot.numChildren()+ _this.state.posts.length,
            posts: TempArray
          }));

          if (_this.state.posts.length - _this.state.limitToFirstNum<0)
          {
            _this.setState({
              hasMore:!_this.state.hasMore
            });
          }

      });

  }


  render() {
    var classDot0 = "Dot active";
    var classDot1= "Dot active";
    var classDot2= "Dot active";
    var classDot3 = "Dot active";
    var classDot4 = "Dot active"

    switch (this.state.actualQuestion+1) {
      case 0: classDot0 = "Dot ";
      case 1: classDot1= "Dot ";
      case 2: classDot2= "Dot ";
      case 3: classDot3= "Dot ";
      case 4: classDot4= "Dot ";
      break;
      default:

    }
    var btnNextText="SUIVANT"
    var hideFlesh=false

      if (this.state.actualQuestion==4)
      {
        btnNextText="TERMINER";
        hideFlesh=true
      }
      var responses= this.state.responses[this.state.actualQuestion].map((item, i) => (
       <button  key={i} className={"ResponseCard "}>
         {item}
       </button>
    ))
    return (
      <div>
        <div className="homeContainer">
          <img src={HomeImg} hidden={this.state.gameFinished} alt="" className="questionsheader"/>
          <img src={imgTerminer} alt='cds' className="questionsheader" hidden={!this.state.gameFinished}/>
          <div className="QuestionNumber" hidden={this.state.gameFinished}>Q{this.state.actualQuestion+1}</div>
          <div  hidden={this.state.gameFinished} className="actualQuestion">{this.state.questions[this.state.actualQuestion]}</div>
          <ul hidden={this.state.gameFinished}>
            {responses}
          </ul>
          <div className="buttonsContainer" hidden={this.state.gameFinished}>
            <Link className="btnAcceuil" hidden={this.state.gameFinished} to="/logout">ACCEUIL</Link>
            <div className="listDots" hidden={this.state.gameFinished}>
              <li className={classDot0}></li>
              <li className={classDot1}></li>
              <li className={classDot2}></li>
              <li className={classDot3}></li>
              <li className={classDot4}></li>
            </div>
            <button className="btnNext" hidden={this.state.gameFinished} onClick={this.goNextQuestion.bind(this)}>{btnNextText} <img hidden={hideFlesh} src={flesh} alt="flesh"/></button>

          </div>

          <Link to="/logout" className="btnGoHome" hidden={!this.state.gameFinished} >ACCEUIL </Link>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js